import { isRejectedWithValue } from '@reduxjs/toolkit';
import { enqueueSnackbar } from 'notistack';
export var ErrorHandlingMiddleware = function () { return function (next) { return function (action) {
    var _a;
    if (isRejectedWithValue(action)) {
        var apiError = action.payload;
        if (apiError.status === 400 || apiError.status === 404) {
            (_a = apiError.data.validationErrors) === null || _a === void 0 ? void 0 : _a.forEach(function (error) {
                return enqueueSnackbar(error, {
                    autoHideDuration: 3000,
                    variant: 'error',
                    anchorOrigin: { horizontal: 'right', vertical: 'top' }
                });
            });
            if (apiError.data.error)
                enqueueSnackbar(apiError.data.error, {
                    autoHideDuration: 3000,
                    variant: 'error',
                    anchorOrigin: { horizontal: 'right', vertical: 'top' }
                });
        }
    }
    return next(action);
}; }; };
